import { useAtomValue } from "jotai";
import { Card, CardHeader, CardContent, Stack, Button } from "@mui/material";
import { FormComponentFactory } from "./FormComponentFactory";
import { useComponentConfigAtom } from "./state/ComponentAtoms";
import { selectedComponentAtom } from "./selectedComponentAtom";
import { useCallback } from "react";

export function PropertiesEditor() {
  const selectedComponent = useAtomValue(selectedComponentAtom);
  const editor = !!selectedComponent ? (
    <ComponentPropertiesEditor componentId={selectedComponent} />
  ) : (
    <div>No Component Selected</div>
  );
  return (
    <Card
      sx={{
        width: "20vw",
        height: "80vh",
        position: "sticky",
        top: "20vh",
        left: "80vw",
      }}
    >
      <CardHeader title="Property Editor"></CardHeader>
      <CardContent>{editor}</CardContent>
    </Card>
  );
}
function ComponentPropertiesEditor({ componentId }: { componentId: string }) {
  const [config, setConfig] = useComponentConfigAtom(componentId);
  const onSave = useCallback(() => {
    setConfig({
      ...config,
      ...{ config: config.editConfig },
    });
  }, [config, setConfig]);
  const onCancel = useCallback(() => {
    setConfig({
      ...config,
      ...{ editConfig: config.config },
    });
  }, [config, setConfig]);
  if (!!config) {
    const editor = !!config
      ? FormComponentFactory.generateEditor(config.type, config)
      : null;
    return (
      <Stack>
        {editor}
        <div>
          <Button onClick={onCancel}>Cancel</Button>
          <Button onClick={onSave}>Save</Button>
        </div>
      </Stack>
    );
  }
  return <div>Component Not Found</div>;
}
